import { useEffect, useRef, useState } from 'react'
import { IconChevronLeft, IconChevronRight, IconCircle } from '@tabler/icons'
import { dayjsInit } from '@ow/utils'
import MonthGrid from './month'

const SingleYear = ({ value, onChange }) => {
  return (
    <div className="flex justify-between items-center border-b px-2 py-1">
      <div className="ml-4">{value}年</div>
      <div className="flex items-center gap-3">
        <div className="p-4 cursor-pointer" onClick={() => onChange(value - 1)}>
          <IconChevronLeft size={14} />
        </div>
        <IconCircle size={14} />
        <div className="p-4 cursor-pointer" onClick={() => onChange(value + 1)}>
          <IconChevronRight size={14} />
        </div>
      </div>
    </div>
  )
}

const Single = ({ value, onChange, onClose }) => {
  const date = dayjsInit(value)
  const current = date.isValid() ? date : dayjsInit()
  const yearRef = useRef(current.year())
  const [year, setYear] = useState(yearRef.current)
  const [month, setMonth] = useState()

  const handleChange = (y, m) => {
    if (onChange) {
      onChange(dayjsInit([y, m]))
    }
  }

  const onMonthChange = (v) => {
    handleChange(year, v)
    setTimeout(onClose, 300)
    if (!value) {
      setMonth(v)
    }
  }

  useEffect(() => {
    if (value && date.isValid()) {
      yearRef.current = date.year()
      setYear(yearRef.current)
      setMonth(date.month())
    }
  }, [value])

  return (
    <div className="font-weight-bold select-none">
      <SingleYear value={year} onChange={setYear} />
      <MonthGrid
        selected={yearRef.current === year ? month : null}
        onSelect={onMonthChange}
      />
    </div>
  )
}

export default Single
